var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 7.8539L8.853 14.8539C8.75911 14.9478 8.63177 15.0005 8.499 15.0005C8.36622 15.0005 8.23889 14.9478 8.145 14.8539C8.05111 14.76 7.99837 14.6327 7.99837 14.4999C7.99837 14.3671 8.05111 14.2398 8.145 14.1459L14.293 7.9999H0.5C0.367392 7.9999 0.240215 7.94722 0.146447 7.85345C0.0526785 7.75968 0 7.63251 0 7.4999C0 7.36729 0.0526785 7.24011 0.146447 7.14635C0.240215 7.05258 0.367392 6.9999 0.5 6.9999H14.293L8.146 0.853899C8.05211 0.760013 7.99937 0.632675 7.99937 0.499899C7.99937 0.367123 8.05211 0.239786 8.146 0.145899C8.23989 0.0520124 8.36722 -0.000732421 8.5 -0.000732422C8.63278 -0.000732423 8.76011 0.0520124 8.854 0.145899L15.854 7.1459C15.9006 7.19234 15.9375 7.24752 15.9627 7.30827C15.9879 7.36901 16.0009 7.43413 16.0009 7.4999C16.0009 7.56567 15.9879 7.63079 15.9627 7.69153C15.9375 7.75228 15.9006 7.80745 15.854 7.8539H15.853Z",
    fill: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBlue);
export default __webpack_public_path__ + "static/media/rightArrowBlue.db9e324d629e23afc0ec24823923beda.svg";
export { ForwardRef as ReactComponent };